 let collectionFee = [];
 containerhalfSelectEl = document.querySelector('.select__select_custom__collection__halfc')
 containerSelectEl = document.querySelector('.select__select_custom__collection__fullc')

 async function defineCollectionVariantIds(months) {
   if (containerhalfSelectEl) {
     await Promise.all(Array.from(containerhalfSelectEl.querySelectorAll('div')).map((opt) => {
       if (opt.getAttribute('data-collection-option') === months) {
         collectionhalf = opt.getAttribute('data-value')
       }
     }))
   }
   if (containerSelectEl) {
     await Promise.all(Array.from(containerSelectEl.querySelectorAll('div')).map((opt) => {
       if (opt.getAttribute('data-collection-option') === months) {
         collectioncontainer = opt.getAttribute('data-value')
       }
     }))
   }
 }

 function toggleProductSelectors(qtyDown, qtyUp, inpt, state) {
   if (state === 'disabled') {
     qtyDown.setAttribute('disabled', true)
     qtyDown.style.pointerEvents = 'none';
     qtyDown.style.backgroundColor = '#CBCBCB';
     qtyUp.style.pointerEvents = 'none';
     qtyUp.style.backgroundColor = '#CBCBCB';
     qtyUp.setAttribute('disabled', true)
     inpt.style.backgroundColor = '#CBCBCB';
   } else if (state === 'enabled') {
     qtyDown.removeAttribute('disabled');
     qtyDown.style.pointerEvents = 'auto';
     qtyDown.style.backgroundColor = 'transparent';
     qtyUp.style.pointerEvents = 'auto';
     qtyUp.style.backgroundColor = 'transparent';
     qtyUp.removeAttribute('disabled');
     inpt.style.backgroundColor = 'transparent';
   }
 }

 function togglingProductQuantitySelector() {
   const qtyUpBtn1El = document.querySelector('button#qty-up-1')
   const qtyUpBtn2El = document.querySelector('button#qty-up-2')
   const qtyDownBtn1El = document.querySelector('button#qty-down-1')
   const qtyDownBtn2El = document.querySelector('button#qty-down-2')
   const btnv1 = document.querySelector('input#btnv-1')
   const btnv2 = document.querySelector('input#btnv-2')

   $(document).on("change", "#btnv-1", function(e) {
     if (Number(e.target.value) > 0) {
       toggleProductSelectors(qtyUpBtn2El, qtyDownBtn2El, btnv2, 'disabled')
     } else {
       toggleProductSelectors(qtyUpBtn2El, qtyDownBtn2El, btnv2, 'enabled')
     }
   })
   $(document).on("change", "#btnv-2", function(e) {
     if (Number(e.target.value) > 0) {
       toggleProductSelectors(qtyUpBtn1El, qtyDownBtn1El, btnv1, 'disabled')
     } else {
       toggleProductSelectors(qtyUpBtn1El, qtyDownBtn1El, btnv1, 'enabled')
     }
   })
 }

 $(document).ready(function() {
   defineCollectionVariantIds('6')
   togglingProductQuantitySelector()
   
     var urlParams = new URLSearchParams(window.location.search);


     // Get the value of 'param1' from the URL
     let pstt = urlParams.get('postcode');
     $('#collection_postcode').val(pstt);
     $.ajax({
         type: "POST",
         url: '/cart/clear.js',
         success: function() {

         },
         dataType: 'json'
     });

 });
 var optionsdatafees = {
     'collectionone': collectionone,
     'collectionthree': collectionthree,
     'collectionfour': collectionfour,
     'collectionhalf': collectionhalf,
     'collectioncontainer': collectioncontainer

 }
 //  jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
 //   updates: {
 //     collectionone: 0,
 // collectionthree: 0,
 //   collectionfour: 0,
 //  collectionhalf: 0,
 //     collectioncontainer: 0,
 //    40567603036233: 0,
 // 40567416389705: 0,
 //   40567416422473: 0,
 //  40567415111753: 0,
 //     40567415603273: 0,
 //    40567415210057:0,
 //  40567476518985: 0
 //   }
 // });


 function isLondonPostcode(postcode) {
     // Regular expression to match the postcode format
     //  var regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}$/i;

     // Array of valid postcode areas for London
     var areas = ["N", "NC", "NP", "NW", "RM", "SE", "SW", "W", "E", "WW", "WA", "WB", "WC", "WD", "WF", "WG", "WH", "WJ", "WK", "WS", "WT", "WU", "EW"];

     // Check if the postcode matches the format and is in the list of valid areas
     return areas;
 }
 var options = {
     types: ['geocode'], // Include all types of addresses
     componentRestrictions: {
         country: "uk"
     }
 };
 var input = document.getElementById('formatted_address_0');
 var autocomplete = new google.maps.places.Autocomplete(input, options);
 // autocomplete.addListener('place_changed', function () {
 //   var place = autocomplete.getPlace();
 //   // You can access the selected place's details here, such as place.name, place.formatted_address, etc.
 // });
 autocomplete.addListener('place_changed', function() {
     var place1 = autocomplete.getPlace();
     var formattedAddress1 = place1.formatted_address;
     var postcodeen = $('#collection_postcode').val();
     input.value = formattedAddress1; // Set the input field value
     $.post('/cart.js', {
         attributes: {
             'PickupAddress': formattedAddress1,
             'Postcode': postcodeen,
             'ZonePage': zonepage
         }
     }).done(function() {

         getCart(async (cart) => {
             // console.log('crtttt'+cart.attributes.PickupAddress);
             // console.log('crttttyh'+cart.attributes.Postcode);
             let collectionFee = await manageCollectionFee(cart.items, cart.attributes.PickupAddress);
             getCart();
         });
     });
 });

 const manageCollectionFee = async (items, address) => {
     // let addressField = document.getElementById('formatted_address_0').value;
     // if ((!address || address.length == 0) && addressField) address = addressField;
     // if (!address || address.length == 0) return false;

     // let addressComponents = (address || '').split(',');
     // let zipCode = addressComponents[addressComponents.length - 1].trim();

   let activeQty = 1
   const qtyEl = document.querySelectorAll('input.qty')
   if (qtyEl) {
     await Promise.all(Array.from(qtyEl).map((qnty) => {
       if (qnty.value > 0) {
         activeQty = qnty.value
       }
     }))
   }



     let options = {
         'collectionone': collectionone,
         'collectionthree': collectionthree,
         'collectionfour': collectionfour,
         'collectionhalf': collectionhalf,
         'collectioncontainer': collectioncontainer,
         // 'free': 40086735257673,
         // 'primary_boxes': 40463379660873,
         // 'secondary_boxes': 40463379693641,
         // 'container_london': 40463379857481,
         // 'container_non_london': 40463379923017,
     }
     var collectionFee = [];
     let boxCount = 0;
     let containerCount = 0;
     let halfcontainerCount = 0;
     let itemscontainer = [
         { id: options.collectionhalf, quantity: 0 },
         { id: options.collectioncontainer, quantity: activeQty },
         { id: options.collectionone, quantity: 0 },
         { id: options.collectionthree, quantity: 0 },
         { id: options.collectionfour, quantity: 0 }

         // Add more items as needed
     ];
     let itemscontainerhalf = [
       { id: options.collectioncontainer, quantity: 0 },
         { id: options.collectionhalf, quantity: activeQty },
         { id: options.collectionone, quantity: 0 },
         { id: options.collectionthree, quantity: 0 },
         { id: options.collectionfour, quantity: 0 }

         // Add more items as needed
     ];
     let itemscontainerone = [
         { id: options.collectioncontainer, quantity: 0 },
         { id: options.collectionhalf, quantity: 0 },
         { id: options.collectionone, quantity: 1 },
         { id: options.collectionthree, quantity: 0 },
         { id: options.collectionfour, quantity: 0 }

         // Add more items as needed
     ];
     let itemscontainerthree = [
         { id: options.collectioncontainer, quantity: 0 },
         { id: options.collectionhalf, quantity: 0 },
         { id: options.collectionone, quantity: 0 },
         { id: options.collectionthree, quantity: 1 },
         { id: options.collectionfour, quantity: 0 }

         // Add more items as needed
     ];
     let itemscontainerfour = [
         { id: options.collectioncontainer, quantity: 0 },
         { id: options.collectionhalf, quantity: 0 },
         { id: options.collectionone, quantity: 0 },
         { id: options.collectionthree, quantity: 0 },
         { id: options.collectionfour, quantity: 1 }

         // Add more items as needed
     ];
     let itemscontainerall = [
         { id: options.collectioncontainer, quantity: 0 },
         { id: options.collectionhalf, quantity: 0 },
         { id: options.collectionone, quantity: 0 },
         { id: options.collectionthree, quantity: 0 },
         { id: options.collectionfour, quantity: 0 }

         // Add more items as needed
     ];

     items.map(item => {
         if (item.handle.indexOf('collection') > -1) return;
         if ((item.handle.indexOf('box') > -1 || item.product_type.indexOf('suitcase') > -1) && item.product_type.indexOf('Materials') == -1) {
             boxCount += item.quantity;
         }
         if (item.handle.indexOf('halfc') > -1) {
             halfcontainerCount += item.quantity;
             // alert(halfcontainerCount+'half');
         }
         if (item.handle.indexOf('fullc') > -1) {
             containerCount += item.quantity;
             // alert(containerCount+'full');
         }
     });

     if (containerCount > 0) {
         itemscontainer.forEach(item => {
             collectionFee.push({
                 id: item.id,
                 quantity: item.quantity
             });
         });

     } else if (halfcontainerCount > 0) {
         itemscontainerhalf.forEach(item => {
             collectionFee.push({
                 id: item.id,
                 quantity: item.quantity
             });
         });

     } else if (boxCount > 0) {
         if (boxCount >= 5) {
             itemscontainerfour.forEach(item => {
                 collectionFee.push({
                     id: item.id,
                     quantity: item.quantity
                 });
             });
         } else if (boxCount >= 3) {
             itemscontainerthree.forEach(item => {
                 collectionFee.push({
                     id: item.id,
                     quantity: item.quantity
                 });
             });
         } else {
             itemscontainerone.forEach(item => {
                 collectionFee.push({
                     id: item.id,
                     quantity: item.quantity
                 });
             });
         }
     } else {
         itemscontainerall.forEach(item => {
             collectionFee.push({
                 id: item.id,
                 quantity: item.quantity
             });
         });
     }
     collectionFee = collectionFee.filter(item => (
         (items.findIndex(i => i.id == item.id) == -1 && item.quantity > 0) ||
         (items.findIndex(i => i.id == item.id) > -1 && item.quantity == 0)
     ));
     if (collectionFee.length == 0) return;

     // This loop removes existing collection fee from cart
     Object.keys(options).map(key => {
         if (collectionFee.findIndex(item => item.id == options[key]) == -1) {
             collectionFee.push({
                 id: options[key],
                 quantity: 0
             });
         }
     });
     let formattedFees = {};
     collectionFee.map((fee) => {
         formattedFees[fee.id] = fee.quantity;
     })

     return updateItems(formattedFees);

 }


 const removeCollectionFee = async (items, address) => {




     let options = {
         'collectionone': collectionone,
         'collectionthree': collectionthree,
         'collectionfour': collectionfour,
         'collectionhalf': collectionhalf,
         'collectioncontainer': collectioncontainer

     }
     var collectionFee = [];

     let itemscontainerall = [{
             id: options.collectioncontainer,
             quantity: 0
         },
         {
             id: options.collectionhalf,
             quantity: 0
         },
         {
             id: options.collectionone,
             quantity: 0
         },
         {
             id: options.collectionthree,
             quantity: 0
         },
         {
             id: options.collectionfour,
             quantity: 0
         }

         // Add more items as needed
     ];
     itemscontainerall.forEach(item => {
         collectionFee.push({
             id: item.id,
             quantity: item.quantity
         });
     });

     collectionFee = collectionFee.filter(item => (
         (items.findIndex(i => i.id == item.id) == -1 && item.quantity > 0) ||
         (items.findIndex(i => i.id == item.id) > -1 && item.quantity == 0)
     ));
     if (collectionFee.length == 0) return;

     Object.keys(options).map(key => {
         if (collectionFee.findIndex(item => item.id == options[key]) == -1) {
             collectionFee.push({
                 id: options[key],
                 quantity: 0
             });
         }
     });
     let formattedFees = {};
     collectionFee.map((fee) => {
         formattedFees[fee.id] = fee.quantity;
     })

     return updateItems(formattedFees);

 }
 var win = $(window);

 // getAddress.autocomplete('formatted_address_0', 'dtoken_hEDzcyiWMr3b2ST1JBLtmGckz5Ud4WhmMz9DN7-JqH03hs1LL4TV541eyhADhPZydlrST5mHKhYi4s0pIfzRRb_QgUIwjEitGBTfADrf7wPV6sUVJFXyJtHnquS4wmQ0wjnlKoG_hD6Y1SJf4dicVYDhTvTyHjGa7CMYmjv_Z4QDIig6aeOED4ytptSnLicYYMVx4UTFUgs');
 var timeRangeHtml = '';
 var indexTime = 0;
 timeRangeArray.forEach(element => {
     if (indexTime == 0) {
         timeRangeHtml += '<div class="time-range-item active" data-time="' + element + '">' + element + '</div>';
     } else {
         timeRangeHtml += '<div class="time-range-item" data-time="' + element + '">' + element + '</div>';
     }
     indexTime++;
 });
 $(".time-range-wrap").html(timeRangeHtml);
 var Shopify = Shopify || {};
 // ---------------------------------------------------------------------------
 // Money format handler
 // ---------------------------------------------------------------------------
 Shopify.money_format = "$";
 Shopify.formatMoney = function(cents, format) {
     if (typeof cents == 'string') {
         cents = cents.replace('.', '');
     }
     var value = '';
     var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
     var formatString = (format || this.money_format);

     function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
     }

     function formatWithDelimiters(number, precision, thousands, decimal) {
         precision = defaultOption(precision, 2);
         thousands = defaultOption(thousands, ',');
         decimal = defaultOption(decimal, '.');

         if (isNaN(number) || number == null) {
             return 0;
         }

         number = (number / 100.0).toFixed(precision);

         var parts = number.split('.'),
             dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
             cents = parts[1] ? (decimal + parts[1]) : '';

         return dollars + cents;
     }

     switch (formatString.match(placeholderRegex)[1]) {
         case 'amount':
             value = formatWithDelimiters(cents, 2);
             break;
         case 'amount_no_decimals':
             value = formatWithDelimiters(cents, 0);
             break;
         case 'amount_with_comma_separator':
             value = formatWithDelimiters(cents, 2, '.', ',');
             break;
         case 'amount_no_decimals_with_comma_separator':
             value = formatWithDelimiters(cents, 0, '.', ',');
             break;
     }

     return formatString.replace(placeholderRegex, value);
 };
 // steps 
 var totalSteps = $(".steps li").length;

 $(".submit").on("click", function() {
     return false;
 });

 $('.toggle-plan-header').on('click', function() {
     if ($(".toggle-plan-header").parent('.toggle-parent').hasClass("active")) {
         $(this).parent('.toggle-parent').removeClass("active");
     } else {
         $(this).parent('.toggle-parent').addClass("active");
         $(this).attr('data-click-state', 1);
     }
 });

 // function toggle packing heading
 $(".show-return").click(function() {
     $(this).toggleClass("active");
     $(".note-return").toggleClass("active");
 })
 // function popup when click title
 $(".click-title, .product-item-storage .img-type").click(function() {
     $('.popup-des').removeClass("show");
     var datahandle = $(this).attr('dataHandle1');
     $('.storage-right').find(".popup-des[dataHandle='" + datahandle + "']").addClass("show");
 });
 $(".popup-des .icon-close").click(function() {
     $('.popup-des').removeClass("show");
 });

 $(document).mouseup(function(e) {
     var container = $('.popup-content');
     // if the target of the click isn't the container nor a descendant of the container
     if (!container.is(e.target) && container.has(e.target).length === 0) {
         $('.popup-des').removeClass("show");
     }
 });

 // slider range input
 var RangeSlider = (function() {
     var elRangeInputs = document.querySelectorAll(".range");

     function setProgress(elTarget) {
         var elRangeBar = elTarget.parentElement;
         var intThumbWidth = elRangeBar.clientHeight * 3;
         var intRangeBarWidth = elRangeBar.clientWidth - intThumbWidth;
         var intThumbWidthOffset = intThumbWidth / 2;

         var intProgressPosition = (elTarget.value - elTarget.min) / (elTarget.max - elTarget.min);
         var intRangePosition = (intRangeBarWidth * intProgressPosition) + intThumbWidthOffset;


     }

     for (var i = 0; i < elRangeInputs.length; i++) {
         elRangeInputs[i].firstElementChild.addEventListener("input", function() {
             setProgress(this);
         });

         setProgress(elRangeInputs[i].firstElementChild);
     }
 })();

 // variables 
 var items = [];
 var collectionTime = false;
 var collectionFeeFlag = false;
 var hasMaterials = false;
 var collectionAdded = false;
 var months = localStorage.getItem("months");
 var itemAvailabel = [];
 var dateElement4 = window.packingMaterials;
 var qtyMaterials = []
 for (var i = 0; i < dateElement4.length; i++) {
     qtyMaterials.push(0);
 };
 // var itemsMaterials1 = [];
 // function copyArray(oldArray, newArray) {
 //     var length = oldArray.length;
 //     for (var i = 0; i < length; i++) {
 //         var storeElement = { id: oldArray.pop(), quantity: 0 };
 //         newArray.push(storeElement);
 //     };
 // }
 // copyArray(dateElement4, itemsMaterials1);
 var itemsMaterials = dateElement4.map(x => {
     return {
         id: x.product_material.variants[0].id,
         quantity: 0
     }
 })
 var checkClick = false;

 // var collectionFee = [
 //     {
 //         id: 40086735257673,
 //         quantity: 1
 //     }
 // ];
 // var collectionFeeUpdate =
 // {
 //     id: 40086735257673,
 //     quantity: 0
 // };

 var updateItemsMaterialsData = [];
 itemsMaterials.forEach(x => {
     updateItemsMaterialsData[x.id] = x.quantity;
 })

 // New startDate attribute to check in order confirmation emails
 let generateStartDate = new Date();
 let startDate = generateStartDate.getDate() + '-' + generateStartDate.toLocaleString('en-GB', {
     month: 'short'
 }) + '-' + generateStartDate.getFullYear();
 //console.log('trttt'+startDate);
 $(".steps li:nth-of-type(1)").addClass("active");
 $(".main-storage-box .form-container:nth-of-type(1)").addClass("active");

 $(".form-container:not(.step-3, .step-4)").on("click", ".next", function() {
     $(".steps li").eq($(this).parents(".form-container").index() + 1).addClass("active");
     $(this).parents(".form-container").removeClass("active").next().addClass("active flipInX");
     $(this).parents(".form-container-wrapper").next().find(".form-container-overlay").addClass("unactive");
     $(this).parents(".form-container-wrapper").next().css('opacity', 1);
     $('.total-sticky').addClass('advanced-step')

     $('html, body').animate({
         scrollTop: $(this).parents(".form-container-wrapper").next().offset().top - 50
     }, 1000);
 });

 // change discount change text discount
 function changeDiscount(months) {
     if (months == 1) {
         $(".note-for-months-1").css('display', 'block');
         $(".note-for-months-other").css('display', 'none');
     } else {
         $(".note-for-months-other").css('display', 'block');
         $(".note-for-months-1").css('display', 'none');
         switch (months) {
             case '3':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-3']);
                 break;
             case '4':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-4']);
                 break;
             case '5':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-5']);
                 break;
             case '6':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-6']);
                 break;
             case '7':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-7']);
                 break;
             case '8':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-8']);
                 break;
             case '9':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-9']);
                 break;
             case '10':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-10']);
                 break;
             case '11':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-11']);
                 break;
             case '12':
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-12']);
                 break;
             default:
                 $(".note-for-months-other .number-discount").html(section1.settings['discount-2']);
         }
     }
 }

 function getPickupAddress(done) {
     $.ajax({
         type: 'GET',
         url: '/cart.js',
         cache: false,
         dataType: 'json',
         success: (cart) => done(cart.attributes.PickupAddress),
     })
 }

 // function get cart
 function getCart(callback = false) {
     var itemsCartElement = '';
     var itemsCoverageElement = '';
     var itemsCartElement2 = '';
     var itemsCartElement3 = '';
     var itemsCartMaterials = 0;
     var itemsCartMaterialsCount = 0;
     var itemsCoveragebox = 0;
     var itemsStoragebox = 0;
     var dateElement8 = window.packingMaterials;

     $.ajax({
         type: 'GET',
         url: '/cart.js',
         cache: false,
         dataType: 'json',
         success: function(cart) {
             items = [];

             if (callback) {
                 callback(cart);
             }
             if (cart.items.length >= 0) {
                 var one_off_payments = 0;
                 let collectionFeeHtml = '';
                 cart.items.forEach(function(item) {
                     items.push(item);
                     if (item.product_type == "collectionfee") {
                         collectionFeeFlag = true;
                     }
                     if (cart.items.length == 1 && item.product_type == 'collectionfee') {
                         collectionFeeFlag = true;
                         var dateElement6 = window.packingMaterials;
                         for (var i = 0; i < dateElement6.length; i++) {
                             qtyMaterials[i] = 0;
                         };
                     }
                     let resul1t = itemsMaterials.map(x => x.id).indexOf(item.product_id) == -1 ? false : true;

                     if (resul1t == true && !(collectionAdded)) {
                         hasMaterials = true;
                     }

                     if (item.product_type == "Packing Materials") {
                         itemsCartMaterialsCount += parseFloat(item.quantity);
                         itemsCartMaterials += parseFloat(item.final_line_price);
                         itemsCartElement2 += '<div class="packing-product-content_item"><p class="name pmaterials">' + item.quantity + 'x ' + item.product_title.replace('(Packaging materials)', '').split("(")[0].trim() + '<span class="details">' + (item.product_title.match(/\((.*?)\)/) ? item.product_title.match(/\((.*?)\)/)[1] : '') + '</span></p><div><span class="price">' + Shopify.formatMoney(item.final_line_price, '£\{\{amount\}\}') + '</span>';
                         one_off_payments += parseFloat(item.final_line_price);
                     } else if (item.handle.indexOf('collection') > -1) {
                         collectionAdded = true;
                         hasMaterials = false;
                         collectionFeeHtml = '<div class="collection-fee-total flex-section flex-sb-just"><p class="name">' + item.product_title + '</p><p class="price">' + (item.final_line_price > 0 ? Shopify.formatMoney(item.final_line_price, '£\{\{amount\}\}') : 'FREE') + '</p></div>'
                         one_off_payments += item.final_line_price;
                     }

                     // if (item.handle.indexOf('collection') > -1 && (item.handle.indexOf('halfc') > -1 || item.handle.indexOf('fullc') > -1)) {
                     //     collectionAdded = true;
                     //     hasMaterials = false;
                     //     collectionFeeHtml = '<div class="collection-fee-total flex-section flex-sb-just"><p class="name">' + item.product_title + '</p><p class="price">' + (item.final_line_price > 0 ? Shopify.formatMoney(item.final_line_price, '£\{\{amount\}\}') : 'FREE') + '</p></div>'
                     //     one_off_payments += item.final_line_price;
                     // }
                     else if (item.product_type == "coverage") {
                         itemsCoveragebox += parseFloat(item.final_line_price);
                         if (item.id == 40567011967049) {
                             var icp = 'Free (included)';
                             var tt = '£100 per box';
                         } else if (item.id == 40567011999817) {
                             var icp = '£0.95 per box per month';
                             var tt = '£250 per box';

                         } else if (item.id == 40567012032585) {
                             var icp = '£2.95 per box per month';
                             var tt = '£500 per box';

                         }

                         if (item.final_line_price <= 0) {
                             var pp = 'FREE';

                         } else {
                             var pp = Shopify.formatMoney(item.final_line_price, '£\{\{amount\}\}');

                         }
                         itemsCoverageElement += '<div class="storage-item flex-section flex-sb-just"><p class="name">' + item.quantity + 'x ' + tt + '<br><span>' + icp + '</span></p><p class="price">' + pp + '</p></div>'
                         $('.included-header').addClass('active');
                     } else {
                         let perText = 'box';
                         if (item.title.toLowerCase().indexOf('container') > -1) perText = 'container';
                         else if (item.title.toLowerCase().indexOf('suitcase') > -1) perText = 'suitcase';
                         itemsStoragebox += parseFloat(item.final_line_price);
                         // itemsStoragebox = calculateDynamicPrice(parseInt(localStorage.getItem('months')), (itemsStoragebox/100))
                         itemsCartElement += '<div class="storage-item flex-section flex-sb-just"><p class="name">' + item.quantity + 'x ' + item.product_title.replace(' (Monthly Storage)', '') + '<br><span>' + Shopify.formatMoney(item.final_price, '£\{\{amount\}\}') + ' per ' + perText + '</span></p><p class="price">' + Shopify.formatMoney(item.final_line_price, '£\{\{amount\}\}') + '</p></div>'
                     }
                 });

                 $(".storage-content").html(itemsCartElement);
                 $(".included-coverage").html(itemsCoverageElement);
                 $(".one-off-payments").html(`<div class="one-off-payments-total flex-section flex-sb-just"><p class="name active">Collection & Materials <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
</svg>
</p><p class="price">${Shopify.formatMoney(one_off_payments, '£\{\{amount\}\}')}</p></div>`);
                 $('.one-off-payments-total .name .icon-caret').on('click', function() {
                     $(this).parent().toggleClass('active');
                     $(".packing-product-content").toggleClass("active");
                 })
                 $('.collection-fee').html(collectionFeeHtml);
                 $(".packing-product-content").html(itemsCartElement3 + itemsCartElement2);
                 $(".packing-product-content").html(itemsCartElement3 + itemsCartElement2);
                 $('.step-1 .btn.next').prop('disabled', false);
                 $('[step="1"] .btn.next').prop('disabled', false);
             }

             if (cart.total_price >= 0) {
                 $('.total-price .number').html(Shopify.formatMoney(cart.total_price, '£\{\{amount\}\}'));
                 $('.total-bar__price').html(Shopify.formatMoney(cart.total_price, '£\{\{amount\}\}'));
             }
             if (cart.items.length == 0) {
                 $('.step-1 .btn.next').prop('disabled', true);
                 $('[step="1"] .btn.next').prop('disabled', true);
                 collectionFeeFlag = false;
                 var dateElement6 = window.packingMaterials;
                 var qtyMaterials = new Array(dateElement6.length).fill(0);
             }
             if (cart.attributes.CollectionDate && cart.attributes.CollectionDate !== '') {
                 $('.collection-date').html('<span class="CollectionDate">' + cart.attributes.CollectionDate + '</span><span class="CollectionTime">' + cart.attributes.CollectionTime + '</span>');
             }
         },
         complete: function(data) {
             updateItemStorage(items);
             $('.total-materials').html(Shopify.formatMoney(itemsCartMaterials, '£\{\{amount\}\}'));
             $('.itemsStoragebox').html(Shopify.formatMoney(itemsStoragebox, '£\{\{amount\}\}'));
             $('.itemsCoveragebox').html(Shopify.formatMoney(itemsCoveragebox, '£\{\{amount\}\}'));

             $('.count-materials').html(itemsCartMaterialsCount + ' items');
             var dateElement6 = window.packingMaterials;
             itemsMaterials.forEach(x => {
                 x.quantity = 0;
             })
             items.forEach(item => {
                 let product_material = window.packingMaterials.find(x => x.storage_product == item.product_id);
                 if (typeof product_material != "undefined") {
                     let product_material_id = product_material.product_material.variants[0].id;
                     let index = itemsMaterials.findIndex(x => x.id == product_material_id);
                     itemsMaterials[index].quantity = item.quantity;
                 }
             })
         }
     });
 }

 // function add item to cart
 function addItem(itemsInput) {
     console.log(itemsInput)
     console.log('Start====jijijijninjinji')
     // alert('step1');
     // alert('start');
     $('.quantity-select').addClass('inactive')
     return $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         data: {
             items: itemsInput
         },
         dataType: 'json',
         success: function() {
             getCart();

         },
         complete: function(data) {
             updateItemStorage(data.items);
             console.log('finish')
             $('.quantity-select').removeClass('inactive')
             $('#months').prop('disabled', false);
             $(".select-radio input[type='radio']").prop('disabled', false);
         }
     });
 }



 function addcoverage(items2) {
     console.log(items2);
     console.log('coverage');

     $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         data: {
             items: items2
         },
         dataType: 'json',
         success: function() {
             console.log('added');
             getCart();

         },
         complete: function(data) {
             console.log(data.items);
             console.log('finishcoverage')

         }
     });
 }

 $(".select-radio-insurance input[type='radio']").on('change', function() {
     removecoverage();
     setTimeout(() => {
         $(".select-radio-insurance input").removeAttr('checked');
         $(this).attr("checked", true);
         coverageitems();
     }, 1000);

 });




 // function add item materials to cart
 function addItemMaterials(items2) {
     console.log(items2)
     $(".step-2 .btn.next").prop('disabled', true);
     $('[step="2"] .btn.next').prop('disabled', true);
     $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         data: {
             items: items2
         },
         dataType: 'json',
         success: function() {
             getCart();
         },
         complete: function(data) {
             updateItemStorage(data.items);
             $('#months').prop('disabled', false);
             $(".select-radio input[type='radio']").prop('disabled', false);
             hasMaterials = true;
             setTimeout(function() {
                 $(".step-2 .btn.next").prop('disabled', false);
                 $('[step="2"] .btn.next').prop('disabled', false);
             }, 1000);
         }
     });

 }

 // function update item in cart
 function updateItem(itemCart) {
     console.log('update item', itemCart)

     return $.ajax({
         type: 'POST',
         url: '/cart/change.js',
         data: itemCart,
         dataType: 'json',
         success: function(e) {},
         complete: function() {
             getCart();
         }
     });
 }

 // function update items in cart
 function updateItems(itemCart) {
     return $.ajax({
         type: 'POST',
         url: '/cart/update.js',
         data: {
             updates: itemCart
         },
         dataType: 'json',
         success: function(e) {},
         complete: function() {
             console.log('updated Items')
             getCart();
         }
     });
 }

 // function update items in cart
 function updateItemscoll(itemCart) {
     return $.ajax({
         type: 'POST',
         url: '/cart/update.js',
         data: {
             updates: itemCart
         },
         dataType: 'json',
         success: function(e) {},
         complete: function() {
             console.log('updated Items')
             // getCart();
         }
     });
 }


 // function update material to 0 in cart
 function updateItemStep1() {
     $(".step-2 .btn.next").prop('disabled', true);
     $('[step="2"] .btn.next').prop('disabled', true);
     $.ajax({
         type: 'POST',
         url: '/cart/update.js',
         data: {
             updates: updateItemsMaterialsData
         },
         dataType: 'json',
         async: true,
         success: function() {},
         complete: function() {
             hasMaterials = false;
             $(".packing-product").css("display", "none");
             $(".select-radio input[type='radio']").prop('disabled', false);
             $(".step-2 .btn.next").prop('disabled', false);
             $('[step="2"] .btn.next').prop('disabled', false);
             collectionFeeFlag = false;
             getCart();
         }
     });
 }

 function updateItemMaterials() {
     console.log(updateItemsMaterialsData)
     $(".step-2 .btn.next").prop('disabled', true);
     $('[step="2"] .btn.next').prop('disabled', true);
     $.ajax({
         type: 'POST',
         url: '/cart/update.js',
         data: {
             updates: Object.assign({}, updateItemsMaterialsData)
         },
         dataType: 'json',
         async: true,
         success: function() {
             getCart();
         },
         complete: function() {
             hasMaterials = false;
             $(".packing-product").css("display", "none");
             $(".select-radio input[type='radio']").prop('disabled', false);
             $(".step-2 .btn.next").prop('disabled', false);
             $('[step="2"] .btn.next').prop('disabled', false);
         }
     });
 }

 // function update item into frontend 
 function updateItemStorage(items1) {
     // alert('step2')
     var totaldefaut = 0;
     if (Array.isArray(items1) && items1.length > 0) {
         items1.forEach(function(item) {
             $('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').find('option').removeClass("active");
             if ($('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').find('.qty').attr('need-update') != 'false') {
                 $('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').find('.qty').val(item.quantity);
             }
             $('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').attr('data-qty', item.quantity);
             $('.storage-products option[value=' + item.id + ']').addClass("active");
             $('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').addClass("active");
             if ($('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').length > 0) {
                 totaldefaut += parseFloat($('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').find('option').eq(0).text().replace("£", "") * $('.storage-products option[value=' + item.id + ']').parents('.product-item-storage').attr('data-qty'));
             } else {
                 totaldefaut += 25;
             }

             $('.packing-section option[value=' + item.id + ']').parents('.packing-item').find('option').removeClass("active");
             $('.packing-section option[value=' + item.id + ']').parents('.packing-item').find('.qty').val(item.quantity);
             $('.packing-section option[value=' + item.id + ']').parents('.packing-item').attr('data-qty', item.quantity);
             $('.packing-section option[value=' + item.id + ']').addClass("active");
             $('.packing-section option[value=' + item.id + ']').parents('.packing-item').addClass("active");
         });
     }
     if (months > 1 && Array.isArray(items1) && items1.length > 0) {
         $('.number-default').html('£' + totaldefaut.toFixed(2));
         $('.total-price').removeClass("color-white");

     } else {
         $('.number-default').html();
         $('.total-price').addClass("color-white");
         $('.number-default').html();
     }
 }


 $('.btn-remove-all-materials').click(function() {
     updateItemMaterials();
 });

 // function remove all item in cart
 $('.btn-remove-all-cart').click(function() {
     $.ajax({
         type: "POST",
         url: '/cart/clear.js',
         data: '',
         dataType: 'json',
         success: function() {
             items = [];
             $(".storage-content").html();
             $('.total-price .number').html('0');
             $('.total-bar__price').html(0);
             $('.product-item-storage').removeClass('active');
             $('.product-item-storage .qty').val(0);
             $('.product-item-storage option').removeClass('active')
             $('.product-item-storage').attr('data-qty', 0);
             $('.packing-material-devi').removeClass('active');
             $('.steps li:nth-child(1)').trigger("click");
             $('.packing-item').removeClass('active');
             $('.packing-item .qty').val(0);
             $('.packing-item option').removeClass('active')
             $('.packing-item').attr('data-qty', 0);
             $('.step-1 .btn.next').prop('disabled', true);
             $('[step="1"] .btn.next').prop('disabled', true);
             $('.packing-product').css("display", "none");
             $('.number-default').html();
             location.reload();
             collectionFeeFlag = false;
         }
     });
 });

 $(".steps li").on("click", function() {
     // window.scrollTo(0, 0);
     var stepVal = $(this).find("span").text();
     var stepdata = parseInt($(this).attr("data-li"));
     console.log(stepdata)
     if (stepdata == 1) {
         $('.form-container-wrapper:eq(1) .form-container-overlay').removeClass('unactive');
         $('.form-container-wrapper:eq(1)').css('opacity', 0.25);
         $('.form-container-wrapper:eq(2) .form-container-overlay').removeClass('unactive');
         $('.form-container-wrapper:eq(2)').css('opacity', 0.25);
     }
     $(this).prevAll().addClass("active");
     $(this).addClass("active");
     $(this).nextAll().removeClass("active");
     $(".main-storage-box .form-container").removeClass("active flipInX");
     $(".main-storage-box .form-container:nth-of-type(" + stepVal + ")").addClass("active flipInX");
     $(".container-custom").attr("step", stepVal);
     if (stepdata == parseInt(1)) {
         updateItemStep1();
         collectionFeeFlag = false;
         updateItems({
             40086735257673: 0,
             40463379660873: 0,
             40463379693641: 0,
             40463379857481: 0,
             40463379923017: 0
         });
         $.post('/cart.js', {
             attributes: {
                 'PackingmaterialsDelivery': "",
                 'SubscriptionMonth': months,
                 'PickupAddress': null,
                 'CollectionDate': "",
                 'CollectionTime': "",
             }
         }).done(function() {
             getCart(async (cart) => {
                 // console.log('crtttt'+cart.attributes.PickupAddress);
                 // console.log('crttttyh'+cart.attributes.Postcode);
                 let collectionFee = await removeCollectionFee(cart.items, cart.attributes.PickupAddress);
                 document.getElementById('formatted_address_0').value = ''
                 //getCart();
             });
         });
     }

 });
 $(document).ready(function() {
     collectionFeeFlag = false;

     $.ajax({
         type: "POST",
         url: '/cart/clear.js',
         data: '',
         dataType: 'json',
         success: function() {
             items = [];
             $(".storage-content").html();
             $('.total-price .number').html('0');
             $('.total-bar__price').html(0);
             $('.included-header').removeClass('active');
             $('.included-coverage').html('');
             $('.product-item-storage').removeClass('active');
             $('.product-item-storage .qty').val(0);
             $('.product-item-storage option').removeClass('active')
             $('.product-item-storage').attr('data-qty', 0);
             $('.packing-material-devi').removeClass('active');
             $('.steps li:nth-child(1)').trigger("click");
             $('.packing-item').removeClass('active');
             $('.packing-item .qty').val(0);
             $('.packing-item option').removeClass('active')
             $('.packing-item').attr('data-qty', 0);
             $('.step-1 .btn.next').prop('disabled', true);
             $('[step="1"] .btn.next').prop('disabled', true);
             $('.packing-product').css("display", "none");
             $('.number-default').html();
             collectionFeeFlag = false;

         },
         complete: function() {
             removecoverage();
             setTimeout(() => {
                 getCart();
             }, 1000);
         }
     });

     // updateItemStep1();
     // if (localStorage.getItem("months") === null) {
     localStorage.setItem('months', '6');
     months = 6;
     // }
     $("#months").val(localStorage.getItem('months'));
     $('.label-months').html(localStorage.getItem('months'));
     $("#months").trigger("click");
     changeDiscount(localStorage.getItem('months'));
     $('.day-4').html(expectedMaterialsDelivery(dateNow));
     $('.day-6').html(expectedCollectionDelivery(dateNow));
     let firstAvailableDate = dateNow.addDays(window.materialDate);
     let firstAvailableDateColection = dateNow.addDays(window.collectionDate);
     let foundAvailable = false;
     let foundAvailableColl = false;
     let availableOffset = window.materialDate;
     let availableOffsetColl = window.collectionDate;

     while (foundAvailable == false) {
         if (checkSaturday(availableOffset) == true) {
             availableOffset++;
             firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
         } else if (checkSunday(availableOffset) == true) {
             availableOffset++;
             firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
         } else if (checkIsCalculatingForFridayBooking(availableOffset)) {
             availableOffset++;
             firstAvailableDate.setDate(firstAvailableDate.getDate() + getOffsetFridayBooking(availableOffset))
             foundAvailable = true
         } else {
             foundAvailable = true;
         }
     }
     while (foundAvailableColl == false) {
         if (checkSaturday(availableOffsetColl) == true) {
             availableOffsetColl++;
             firstAvailableDateColection.setDate(firstAvailableDateColection.getDate() + 1);
         } else if (checkSunday(availableOffsetColl) == true) {
             availableOffsetColl++;
             firstAvailableDateColection.setDate(firstAvailableDateColection.getDate() + 1);
         } else {
             foundAvailableColl = true;
         }
     }
     $('.day-4').html(dateFormatReadablepckg(firstAvailableDate));
     $('.day-2').html(dateFormatReadablepckg(firstAvailableDate));
     // $('.day-4').html(dateFormatReadable(firstAvailableDate));
     // $('.day-2').html(dateFormatReadable(firstAvailableDate));

     foundAvailable = false;
     availableOffset = availableOffset + (window.collectionDate - window.materialDate);
     firstAvailableDate = firstAvailableDate.addDays(window.collectionDate - window.materialDate);

     while (foundAvailable == false) {
         if (checkSaturday(availableOffset) == true) {
             availableOffset++;
             firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
         } else if (checkSunday(availableOffset) == true) {
             availableOffset++;
             firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
         } else {
             foundAvailable = true;
         }
     }
     $('.day-6').html(dateFormatReadable(firstAvailableDate));


     var selected = $(".select-radio input[type='radio']:checked");
     Calendar.init();


     $.getJSON('/cart.js', function(cart) {
         // Create cart attributes
         cart.attributes.ZonePage = null;
         cart.attributes.FromAdress = null;
         cart.attributes.FromFlatNo = null;
         cart.attributes.CollectionDate = null;
         cart.attributes.CollectionTime = null;
         cart.attributes.ToAddress = null;
         cart.attributes.ToFlatNo = null;
         cart.attributes.SubscriptionMonth = months;
         cart.attributes.PackingmaterialsDelivery = null;
         cart.attributes.StartDate = null;
         cart.attributes.FlatNo = null;
         cart.attributes.PickupAddress = null;
         cart.attributes.Instructions = null;
         cart.attributes.Postcode = null;
         cart.attributes.AdditionalAddressInformation = null;

         // Update the cart on the server
         $.post('/cart/update.js', {

             attributes: cart.attributes
         }, function(response) {
             // let collectionFee = removeCollectionFee(cart.items, cart.attributes.PickupAddress);
             // Handle the response, if needed
             console.log("Cart updated:", response);

         }, 'json');
     });

     $(".select-radio input[type='radio']").on('change', function() {
         switch ($(this).val()) {
             case 'yes':
                 $('.packing-section').addClass("show active");
                 $(".packing-material-date").html($('.day-4').html());
                 $(".packing-material-devi").addClass("active");
                 $(".packing-product").css("display", "block");
                 $(".select-radio input[type='radio']").prop('disabled', true);
                 if (selected.length > 0 && selected.attr("id") == "yes") {
                     updateItem(itemsMaterials);
                 } else {
                     addItemMaterials(itemsMaterials);
                 }
                 $(".select-radio input").removeAttr('checked');
                 $(this).attr("checked", true);
                 setTimeout(function() {
                     $(".step-1 .btn.next").prop('disabled', false);
                     $('[step="1"] .btn.next').prop('disabled', false);
                 }, 2000);
                 break;
             case 'no':
                 $(".select-radio input[type='radio']").prop('disabled', true);
                 $('.packing-section').removeClass("show active");
                 $(".packing-material-date").html("");
                 $(".packing-material-devi").removeClass("active");
                 $(".packing-product").css("display", "none");
                 updateItemMaterials();
                 $(".select-radio input").removeAttr('checked');
                 $(this).attr("checked", true);
                 setTimeout(function() {
                     $(".step-2 .btn.next").prop('disabled', false);
                     $('[step="2"] .btn.next').prop('disabled', false);
                 }, 2000);
                 break;
         }
     });

 });

 const debounce1 = (callback, time) => {
     window.clearTimeout(time);
     debounceTimer = window.setTimeout(callback, time);
 };

 // function change months behavior
 document.getElementById('months').addEventListener('change', function(e) {
     $('.form-container-wrapper:eq(1) .form-container-overlay').removeClass('unactive');
     $('.form-container-wrapper:eq(1)').css('opacity', 0.25);
     $('.form-container-wrapper:eq(2) .form-container-overlay').removeClass('unactive');
     $('.form-container-wrapper:eq(2)').css('opacity', 0.25);
     var PlanMonthtly = 0;
     const updateDebounceCount = () => {
         PlanMonthtly = $(this).val();
         let monthLabel = PlanMonthtly == 12 ? PlanMonthtly + '+' : PlanMonthtly;

         $('.label-months').html(monthLabel);
         months = PlanMonthtly;
         localStorage.setItem('months', months);
         changeDiscount(months);
         defineCollectionVariantIds(months)
         $(this).prop('disabled', true);
         if (PlanMonthtly >= 1) {
             $('.plan-reset').addClass("active-unsure");
         } else {
             $('.plan-reset').removeClass("active-unsure");
             $(".number-default").html();
         }
         if (items.length > 0) {
             months = $(this).val();
             var valueItem = $(this).val() - 1;
             items = [];
             $.ajax({
                 type: "POST",
                 url: '/cart/clear.js',
                 data: '',
                 dataType: 'json',
                 success: function(e) {
                     $('.product-item-storage.active').each(function() {
                         $(this).find(".select__select_custom option").removeClass("active");
                         var indexItem = parseInt($(this).attr('data-index-loop')) - 1;
                         var addItem1 = {
                             id: $(this).find(".select__select_custom option").eq(valueItem).val(),
                             quantity: parseInt($(this).attr('data-qty')),
                             properties: {
                                 '_indexItem': indexItem
                             }
                         };
                         var addItem2 = $(this).attr('selling_plan') == '' ? {
                             id: $(this).find(".select__select_custom option").eq(valueItem).val(),
                             quantity: parseInt($(this).attr('data-qty')),
                             properties: {
                                 '_indexItem': indexItem
                             }
                         } : {
                             id: $(this).find(".select__select_custom option").eq(valueItem).val(),
                             quantity: parseInt($(this).attr('data-qty')),
                             selling_plan: parseInt($(this).attr('selling_plan')),
                             properties: {
                                 '_indexItem': indexItem
                             }
                         }
                         if (months >= 1) {
                             items.push(addItem2);
                         } else {
                             items.push(addItem1);
                             $(".number-default").html();

                         }
                         $(this).find(".select__select_custom option").eq(valueItem).addClass("active");
                     });
                 },
                 complete: function(data) {
                     addItem(items);
                     hasMaterials = false;
                     collectionFeeFlag = false;

                     if (months <= 1) {
                         $(".number-default").html();
                     }
                 }
             });
         } else {
             $(this).prop('disabled', false);
         }
     };
     debounce1(updateDebounceCount, 500);
 });

 // function click next in step 1
 $('.step-1 .next').click(function() {
     console.log('collectionFeeFlag');
     console.log(collectionFeeFlag);
     console.log('hss' + hasMaterials);
     $('.container-custom').attr("step", 2);
     //window.scrollTo(0, 0);
     var selectedVal2 = "";
     var selected2 = $(".select-radio input[type='radio']:checked");
     if (selected2.length > 0) {
         selectedVal2 = selected2.attr("id");
     }

     if (selectedVal2 == 'test1') {
         $('.packing-section').addClass("show active");
         $(".packing-material-date").html($('.day-4').html());
         $(".packing-material-devi").addClass("active");
         $(".packing-product").css("display", "block");

         $('.step-2 .btn.next').prop('disabled', false);
         $('[step="2"] .btn.next').prop('disabled', false);
         if (hasMaterials == false) {

             $.ajax({
                 type: 'POST',
                 url: '/cart/update.js',
                 data: {
                     updates: Object.assign({}, updateItemsMaterialsData)
                 },
                 dataType: 'json',
                 async: true,
                 success: function() {
                     $("input#test1").prop("checked", true).trigger("change");
                     setTimeout(function() {


                         getCart(async (cart) => {
                             // alert('falsem');
                             console.log(cart.attributes.PickupAddress)
                             // let collectionFee = await manageCollectionFee(cart.items, null);
                         });
                     }, 500);

                 }
             });
         }
     } else {

         getCart(async (cart) => {
             // alert('truem');
             //   let collectionFee = await manageCollectionFee(cart.items, cart.attributes.PickupAddress);
             updateItemMaterials();

         });
     }

 });

 // function update qty up 
 $(document).on("click", ".qty-up", function() {

     let $this = $(this);
     var btnid = $this.attr('data-btn');
     var old_value = $('#btnv-' + btnid).val();
     var new_value = parseInt(old_value) + 1;
     // alert(btnid);
     //alert(old_value);
     // alert(new_value);
     $(this).parents('.product-item-storage').attr('data-qty', new_value);
     $('#qty-down-' + btnid).attr('disabled', false);
     $('#btnv-' + btnid).val(new_value).trigger('change');

     storageChoice = $(this).closest('.product-item-right').find('.click-title')
     localStorage.setItem("Booking_storage", storageChoice.text())

 });

 // function update qty down 
 $(document).on("click", ".qty-down", function() {

     let $this = $(this);
     var btnid = $this.attr('data-btn');
     var old_value = $('#btnv-' + btnid).val();
     var new_value = parseInt(old_value) - 1;
     $(this).parents('.product-item-storage').attr('data-qty', new_value);
     $('#btnv-' + btnid).val(new_value).trigger('change');



     if (new_value == 0) {

         $this.attr('disabled', true);

     }



 });


 function debounce(func, wait, immediate) {
     var timeout;

     return function executedFunction() {
         var context = this;
         var args = arguments;

         var later = function() {
             timeout = null;
             if (!immediate) func.apply(context, args);
         };

         var callNow = immediate && !timeout;

         clearTimeout(timeout);

         timeout = setTimeout(later, wait);

         if (callNow) func.apply(context, args);
     };
 };
 var changeQty = debounce(function() {

     $(".section-insurance").removeClass("active flipInX");
     $('.form-container-wrapper:eq(4) .form-container-overlay').removeClass('unactive');
     $('.insurance-wrapper').css('opacity', 0.25);
     //removecoverage();




     var qtyChange = $(this).val();
     $(this).attr('need-update', false);
     hasMaterials == false;
     var itemVal1 = $(this).parents('.product-item-storage').find('.select__select_custom option').eq(months - 1).val();
     var indexItem3 = parseInt($(this).parents('.product-item-storage').attr('data-index-loop')) - 1;

     var sellingPlan = $(this).parents('.product-item-storage').attr("selling_plan");
     if ($(this).parents('.product-item-storage').hasClass("active")) {
         //  alert('test');
         var item2 = months > 1 ? {
             id: itemVal1,
             quantity: qtyChange,
             selling_plan: sellingPlan,
             properties: {
                 '_indexItem': indexItem3
             }
         } : {
             id: itemVal1,
             quantity: qtyChange,
             selling_plan: sellingPlan,
             properties: {
                 '_indexItem': indexItem3
             }
         }
         updateItem(item2);
     } else {
         // alert('test2');
         $(this).parents('.product-item-storage').addClass("active");
         var item2 = months > 1 ? [{
             id: itemVal1,
             quantity: qtyChange,
             selling_plan: sellingPlan,
             properties: {
                 '_indexItem': indexItem3
             }
         }] : [{
             id: itemVal1,
             quantity: qtyChange,
             selling_plan: sellingPlan,
             properties: {
                 '_indexItem': indexItem3
             }
         }];
         addItem(item2);
     }
     if (qtyChange == 0) {
         $(this).parents('.product-item-storage').removeClass("active");
         $(this).parents('.product-item-storage option').removeClass("active");
         $(this).parents('.product-item-storage').find('.qty').val(0);
         var dataIndexMinus = parseInt($(this).parents('.product-item-storage').attr('data-index-loop') - 1);
         qtyMaterials[dataIndexMinus] = 0;
         var item3 = {
             id: itemVal1,
             quantity: 0,
             properties: {
                 '_indexItem': indexItem3
             }
         }
         updateItem(item3);
     }

     var parentStep1 = $('.step-1');
     if (!parentStep1.hasClass('active')) {

         setTimeout(function() {
             $('.steps li[data-li="1"]').click();
         }, 1000);
         setTimeout(function() {
             updateItemMaterials();
         }, 1500);


     }


 }, 00);
 // function change qty input
 $(document).on("change", ".qty", changeQty);

 var cartNote = "";
 var cartNote2 = "";
 var cartNote3 = "";
 const step3HandleCheckout = (pickupAddress) => {
     let addressField = document.getElementById('formatted_address_0').value;
     let instructions = document.getElementById('instructions').value;

     if (addressField == '') {
         document.getElementById('formatted_address_0').closest('.input-form').querySelector('span').style.display = "block";

     }
     // else if(instructions==''){
     //    document.getElementById('formatted_address_0').closest('.input-form').querySelector('span').style.display = "none";
     // // document.getElementById('instructions').closest('.input-form').querySelector('span').style.display = "block";

     // }
     else {
         document.getElementById('formatted_address_0').closest('.input-form').querySelector('span').style.display = "none";
         // document.getElementById('instructions').closest('.input-form').querySelector('span').style.display = "none";
         $.post('/cart.js', {
             attributes: {
                 'PickupAddress': addressField,
                 'FlatNo': instructions,
                 'PackingmaterialsDelivery': cartNote,
                 'SubscriptionMonth': months,
                 'CollectionDate': cartNote2,
                 'CollectionTime': cartNote3,
                 'StartDate': startDate,
                 'ZonePage': zonepage
             }
         }).done(function() {
             getCart(async (cart) => {
                 let collectionFee = await manageCollectionFee(cart.items, cart.attributes.PickupAddress);

                 console.log('pickk' + cart.attributes.PickupAddress);
                 console.log('flat' + cart.attributes.FlatNo);
                 console.log('pckg' + cart.attributes.PackingmaterialsDelivery);
                 console.log('month' + cart.attributes.SubscriptionMonth);
                 console.log('date' + cart.attributes.CollectionDate);
                 console.log('time' + cart.attributes.CollectionTime);
                 console.log('start' + cart.attributes.StartDate);
                 console.log('ZonePage' + cart.attributes.ZonePage);
                 getCart();
                 // return false;
                 $(".steps").css("display", "none");
                 $('.section-loading').addClass("active");
                 $('.total-section').css("display", "none");
                 window.location.href = "/checkout"
             });
         })

     }

 }
 $('.form-container-wrapper .form-container.step-2').on('click', function(event) {
     if ($('.container-custom.flex-section').attr('step') == 3 && !event.target.classList.contains('next')) {
         $('.steps li[data-li="2"]').click();
         $('.form-container-wrapper:eq(2) .form-container-overlay').removeClass('unactive');
         $('.form-container-wrapper:eq(2)').css('opacity', 0.25);
         //$('.total-sticky').removeClass('advanced-step')
     }
 });
 // behavior when click btn next in step 2
 $('.step-3 .btn-primary.next').on('click', function() {

     let addressField = document.getElementById('formatted_address_0').value;
     let instructions = document.getElementById('instructions').value;

     if (addressField == '') {
         document.getElementById('formatted_address_0').closest('.input-form').querySelector('span').style.display = "block";

     }
     // else if(instructions==''){
     //    document.getElementById('formatted_address_0').closest('.input-form').querySelector('span').style.display = "none";
     // // document.getElementById('instructions').closest('.input-form').querySelector('span').style.display = "block";

     // }
     else {
         document.getElementById('formatted_address_0').closest('.input-form').querySelector('span').style.display = "none";
         // document.getElementById('instructions').closest('.input-form').querySelector('span').style.display = "none";



         getCart(async (cart) => {
             console.log('pickk' + cart.attributes.PickupAddress);
             console.log('flat' + cart.attributes.FlatNo);
             console.log('pckg' + cart.attributes.PackingmaterialsDelivery);
             console.log('month' + cart.attributes.SubscriptionMonth);
             console.log('date' + cart.attributes.CollectionDate);
             console.log('time' + cart.attributes.CollectionTime);
             console.log('start' + cart.attributes.StartDate);
             console.log('ZonePage' + cart.attributes.ZonePage);


             // Get the value of 'param1' from the URL
             let addressComponents = $('.postsearch').val();
             // if (addressComponents) {
             //   console.log('param1 value:', addressComponents);

             // }

             // console.log('adddd'+cart.attributes.PickupAddress);
             let address = cart.attributes.PickupAddress;

             // let zipCode = addressComponents[addressComponents.length - 1].trim();
             //  console.log('zzz'+addressComponents);

             if (addressComponents) {
                 if (isLondonPostcode(addressComponents)) {
                     $(this).parents(".form-container").removeClass("active").next().addClass("active flipInX");
                     $(this).parents(".form-container-wrapper").next().find(".form-container-overlay").addClass("unactive");
                     $(this).parents(".form-container-wrapper").next().css('opacity', 1);
                     $('html, body').animate({
                         scrollTop: $(this).parents(".form-container-wrapper").next().offset().top - 50
                     }, 1000);
                     removecoverage();
                     setTimeout(() => {
                         coverageitems();
                     }, 1500);



                 } else {
                     removecoverage();
                     $('.form-container-wrapper:eq(4) .form-container-overlay').removeClass('unactive');
                     $('.insurance-wrapper').css('opacity', 0.25);
                     getPickupAddress(step3HandleCheckout);

                 }
             } else {
                 getPickupAddress(step3HandleCheckout);

             }

         });
         // getPickupAddress(step3HandleCheckout);
     }
 });



 $('.step-4 .btn-primary.next').on('click', function() {
     getPickupAddress(step3HandleCheckout);
 });

 function addcovitems() {
     var totalbox = 0;
     $('.product-item-storage.active[data-qty]').each(function() {
         // alert($(this).data('qty'));
         var bqty = $(this).data('qty');
         totalbox += bqty;


     });
     //alert(totalbox);

     var items2 = [{
         id: 40567011967049,
         quantity: totalbox,
         selling_plan: 768704585
     }];
     addcoverage(items2);

 }

 function removecoverage() {

     $.ajax({
         type: 'GET',
         url: '/cart.js',
         cache: false,
         dataType: 'json',
         success: function(cart) {
             if (cart.items.length > 0) {
                 cart.items.forEach(function(item) {
                     if (item.product_type == "coverage") {
                         jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                             updates: {
                                 40567011967049: 0,
                                 40567011999817: 0,
                                 40567012032585: 0
                             }
                         });
                         $('.included-header').removeClass('active');
                         $('.included-coverage').html('');
                     }
                 });

             }
         }
     });

 }

 function coverageitems() {


     var totalbox = 0;
     $('.product-item-storage.active[data-qty]').each(function() {
         // alert($(this).data('qty'));
         var bqty = parseInt($(this).attr("data-qty"));
         totalbox += bqty;

     });
     //alert(totalbox);

     var selectedcoverage = $(".select-radio-insurance input[type='radio']:checked").val();
     //alert(selectedcoverage);
     switch (selectedcoverage) {
         case 'firstinsurance':
             var items2 = [{
                 id: 40567011967049,
                 quantity: totalbox,
                 selling_plan: 768704585
             }];
             addcoverage(items2);
             break;
         case 'secondinsurance':

             var items2 = [{
                 id: 40567011999817,
                 quantity: totalbox,
                 selling_plan: 768704585

             }];
             addcoverage(items2);

             break;
         case 'thirdinsurance':

             var items2 = [{
                 id: 40567012032585,
                 quantity: totalbox,
                 selling_plan: 768704585
             }];
             addcoverage(items2);

             break;
     }


 }

 $('.step-2 .btn-primary.next').on('click', function() {
     //window.scrollTo(0, 0);has
     var selectedVal = "";
     var selected = $(".select-radio input[type='radio']:checked");
     if (selected.length > 0) {
         selectedVal = selected.attr("id");
     }
     if (selectedVal == 'test1') {
         //  cartNote = cartNote2;
         cartNote = $('.day-4').html();
         // cartNote = dateFormat(cartNoteW);

         $('.packing-material-devi').addClass("active");
         $('.packing-material-date').html(cartNote);
     } else {
         cartNote = "";
         $('.packing-material-devi').removeClass("active");
         $('.packing-material-date').html("");
     }
     if (collectionFeeFlag == false) {
         setTimeout(function() {
             addItem(collectionFee);
         }, 2000);
     }
     $.post('/cart.js', {
         attributes: {
             'PackingmaterialsDelivery': cartNote,
             'SubscriptionMonth': months,
             'PickupAddress': $("#formatted_address_0").val()
         }
     }).done(function() {
         getCart();
         updateItemStorage();
         Calendar.changeInit();
         Calendar.render();
     });

     $('.container-custom').attr("step", 3);
 });

 $('.storage-line .header-label .icon-caret').on('click', function() {
     $(this).parent().toggleClass('active');
     $('.storage-content').toggleClass('active');
 });
 $('.included-header .header-label .icon-caret').on('click', function() {
     $(this).parent().toggleClass('active');
     $('.included-coverage').toggleClass('active');
 })

 // var addrss = document.getElementById('formatted_address_0');
 // $(addrss).change(function(){
 //    var addrssValue = addrss.value;
 //     if (checkClick == true) {
 //         $('.step-3 .btn.next').prop('disabled', false);
 //         $('[step="3"] .btn.next').prop('disabled', false);
 //     }
 //     $.post('/cart.js', {
 //         attributes: {
 //             'PackingmaterialsDelivery': cartNote2,
 //             'SubscriptionMonth': months,
 //             'PickupAddress': addrssValue,
 //             'CollectionDate': cartNote2,
 //             'CollectionTime': cartNote3,
 //             'StartDate': startDate
 //         }
 //     }).done(function () {

 //         getCart(async (cart) => {
 //            console.log('crtttt'+cart.attributes.PickupAddress);
 //             let collectionFee = await manageCollectionFee(cart.items, cart.attributes.PickupAddress);

 //             getCart();
 //         });
 //     });
 // })
 // behavior when click btn next in step 3

 // focus date
 var dateNow = (new Date());

 function dateFormat(date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = date.getDate();

     if (day < 10) {
         day = "0" + day;
     }
     return day + "/" + month + "/" + year;
 }

 function dateFormatReadable(date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = date.toLocaleString("default", {
         weekday: "short"
     });
     var date = date.getDate();
     var monthName = getMonthName(month);
     if (day < 10) {
         day = "0" + day;
     }
     return day + ", " + date + nthNumber(date) + " " + monthName;
 }

 function dateFormatReadablepckg(date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = date.toLocaleString("default", {
         weekday: "short"
     });
     var date = date.getDate();
     var monthName = getMonthName(month);
     if (day < 10) {
         day = "0" + day;
     }
     return day + ", " + date + nthNumber(date) + " " + monthName + " " + year;
 }

 function dateFormat2(date) {
     var year = dateNow.addDays(2).getFullYear();
     var month = dateNow.addDays(2).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(2).getDate();

     if (day < 10) {
         day = "0" + day;
     }
     return day + "/" + month + "/" + year;
 }

 function dateFormat3(date) {
     var year = dateNow.addDays(3).getFullYear();
     var month = dateNow.addDays(3).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(3).getDate();

     if (day < 10) {
         day = "0" + day;
     }
     return day + "/" + month + "/" + year;
 }

 function dateFormat6(date) {
     var year = dateNow.addDays(6).getFullYear();
     var month = dateNow.addDays(6).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(6).getDate();

     if (day < 10) {
         day = "0" + day;
     }
     return day + "/" + month + "/" + year;
 }


 function expectedCollectionDelivery(date) {
     var year = dateNow.addDays(window.collectionDate).getFullYear();
     var month = dateNow.addDays(window.collectionDate).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(window.collectionDate).toLocaleString("default", {
         weekday: "short"
     });
     var date = dateNow.addDays(window.collectionDate).getDate();
     var monthName = getMonthName(month);
     if (day < 10) {
         day = "0" + day;
     }
     return day + ", " + date + nthNumber(date) + " " + monthName;
 }

 function dateFormat7(date) {
     var year = dateNow.addDays(7).getFullYear();
     var month = dateNow.addDays(7).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(7).getDate();

     if (day < 10) {
         day = "0" + day;
     }
     return day + "/" + month + "/" + year;
 }

 function dateFormat8(date) {
     var year = dateNow.addDays(window.collectionDate).getFullYear();
     var month = dateNow.addDays(window.collectionDate).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(window.collectionDate).getDate();

     if (day < 10) {
         day = "0" + day;
     }
     return day + "/" + month + "/" + year;
 }


 function getMonthName(month) {

     var monthShortNames = ["Jan", "Feb", "March", "April", "May", "June",
         "July", "August", "Sep", "Oct", "Nov", "Dec"
     ];
     return monthShortNames[month - 1];
 }

 const nthNumber = (number) => {
     if (number > 3 && number < 21) return "th";
     switch (number % 10) {
         case 1:
             return "st";
         case 2:
             return "nd";
         case 3:
             return "rd";
         default:
             return "th";
     }
 };

 function expectedMaterialsDelivery(date) {
     var year = dateNow.addDays(window.materialDate).getFullYear();
     var month = dateNow.addDays(window.materialDate).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(window.materialDate).toLocaleString("default", {
         weekday: "short"
     });
     var date = dateNow.addDays(window.materialDate).getDate();
     var monthName = getMonthName(month);
     if (day < 10) {
         day = "0" + day;
     }
     return day + ", " + date + nthNumber(date) + " " + monthName;
 }

 function dateFormat4(date) {
     var year = dateNow.addDays(window.materialDate).getFullYear();
     var month = dateNow.addDays(window.materialDate).getMonth();
     month = month + 1;

     if (month < 10) {
         month = "0" + month;
     }
     var day = dateNow.addDays(window.materialDate).getDate();

     if (day < 10) {
         day = "0" + day;
     }
     return day + "/" + month + "/" + year;
 }

 Date.prototype.addDays = function(days) {
     var dateConvert = new Date(this.valueOf());
     dateConvert.setDate(dateConvert.getDate() + days);

     return dateConvert;
 }

 function checkweekend(dateString) {
     var parts = dateString.split("/");
     var day = parseInt(parts[0]);
     var month = parseInt(parts[1]) - 1;
     var year = parseInt(parts[2]);

     var date = new Date(year, month, day);
     var dayOfWeek = date.getDay();

     if (dayOfWeek === 0) {
         return true
     } else if (dayOfWeek === 6) {
         return true
     } else {
         return false
     }
 }

 function checkSunday(days) {
     if (dateNow.addDays(days).getDay() == 0) {
         return true;
     } else {
         return false;
     }
 }

 function checkSaturday(days) {
     if (dateNow.addDays(days).getDay() == 6) {
         return true;
     } else {
         return false;
     }
 }

 function checkIsCalculatingForFridayBooking(days) { // check if current day is Friday and pre-calculated collection day falls on Monday or Tuesday
     if (dateNow.getDay() === 5 && (dateNow.addDays(days).getDay() == 1 || dateNow.addDays(days).getDay() == 2)) {
         return true;
     } else {
         return false;
     }
 }

 function getOffsetFridayBooking(days) {
     return dateNow.addDays(days).getDay()
 }

 // render calendar in step 3
 var d = new Date();
 var Calendar = {
     themonth: d.getMonth(), // The number of the month 0-11
     theyear: d.getFullYear(), // This year
     today: [d.getFullYear(), d.getMonth(), d.getDate()], // adds today style
     selectedDate: null, // set to today in init()
     years: [], // populated with last 10 years in init()
     months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

     init: function() {



         const disableDate1 = [];
         const disableDate = localStorage.getItem("dateDisable")?.replace(/\s/g, "");
         dateElement1 = disableDate ? disableDate.split(",").map(date => date.trim()) : [];

         var selectedVal1 = "";
         var selected1 = $(".select-radio input[type='radio']:checked");
         if (selected1.length > 0) {
             selectedVal1 = selected1.attr("id");
         }
         if (selectedVal1 == 'test1') {

             //this.selectedDate = [d.getFullYear(), d.getMonth(), d.getDate() + 4];

         } else {
             this.selectedDate = [d.getFullYear(), d.getMonth(), d.getDate() + 1];
         }

         // Populate the list of years in the month/year pulldown
         var year = this.theyear;
         for (var i = 0; i < 10; i++) {
             this.years.push(year--);
         }
         this.bindUIActions();
         this.render();
     },
     changeInit: function() {

         var selectedVal3 = "";
         var selected3 = $(".select-radio input[type='radio']:checked");
         if (selected3.length > 0) {
             selectedVal3 = selected3.attr("id");
         }

         if (selectedVal3 == 'test1') {
             this.selectedDate = [d.getFullYear(), d.getMonth(), d.getDate() + 5];
         } else {
             this.selectedDate = [d.getFullYear(), d.getMonth(), d.getDate() + 1];
         }
     },

     bindUIActions: function() {
         // Create Years list and add to ympicker
         for (var i = 0; i < this.years.length; i++)
             $('<li>' + this.years[i] + '</li>').appendTo('.calendar-ympicker-years');
         this.selectMonth();
         this.selectYear(); // Add active class to current month n year

         // Slide down year month picker
         $('.monthname').click(function() {
             $('.calendar-ympicker').css('transform', 'translateY(0)');
         });

         // Close year month picker without action
         $('.close').click(function() {
             $('.calendar-ympicker').css('transform', 'translateY(-100%)');
         });

         // Move calander to today
         $('.today').click(function() {
             Calendar.themonth = d.getMonth();
             Calendar.theyear = d.getFullYear();
             Calendar.selectMonth();
             Calendar.selectYear();
             Calendar.selectedDate = Calendar.today;
             Calendar.render();
             $('.calendar-ympicker').css('transform', 'translateY(-100%)');
         });

         // Click handlers for ympicker list items
         $('.calendar-ympicker-months li').click(function() {
             Calendar.themonth = $('.calendar-ympicker-months li').index($(this));
             Calendar.selectMonth();
             Calendar.render();
             $('.calendar-ympicker').css('transform', 'translateY(-100%)');
         });
         $('.calendar-ympicker-years li').click(function() {
             Calendar.theyear = parseInt($(this).text());
             Calendar.selectYear();
             Calendar.render();
             $('.calendar-ympicker').css('transform', 'translateY(-100%)');
         });

         // Move the calendar pages
         $('.minusmonth').click(function() {
             Calendar.themonth += -1;
             Calendar.changeMonth();
         });
         $('.addmonth').click(function() {
             Calendar.themonth += 1;
             Calendar.changeMonth();
         });
     },

     // Adds class="active" to the selected month/year
     selectMonth: function() {
         $('.calendar-ympicker-months li').removeClass('active');
         $('.calendar-ympicker-months li:nth-child(' + (this.themonth + 1) + ')').addClass('active');
     },
     selectYear: function() {
         $('.calendar-ympicker-years li').removeClass('active');
         $('.calendar-ympicker-years li:nth-child(' + (this.years.indexOf(this.theyear) + 1) + ')').addClass('active');
     },

     // Makes sure that month rolls over years correctly
     changeMonth: function() {
         if (this.themonth == 12) {
             this.themonth = 0;
             this.theyear++;
             this.selectYear();
         } else if (this.themonth == -1) {
             this.themonth = 11;
             this.theyear--;
             this.selectYear();
         }
         if (Calendar.today[1] > this.themonth) {
             $('.calendar-body').addClass("disable");
         } else {
             $('.calendar-body').removeClass("disable");
         }
         this.selectMonth();
         this.render();
     },

     // Helper functions for time calculations
     TimeCalc: {
         firstDay: function(month, year) {
             var fday = new Date(year, month, 1).getDay(); // Mon 1 ... Sat 6, Sun 0
             if (fday === 0) fday = 7;
             return fday - 1; // Mon 0 ... Sat 5, Sun 6
         },
         numDays: function(month, year) {
             return new Date(year, month + 1, 0).getDate(); // Day 0 is the last day in the previous month
         }
     },

     render: function() {
         var days = this.TimeCalc.numDays(this.themonth, this.theyear), // get number of days in the month
             fDay = this.TimeCalc.firstDay(this.themonth, this.theyear), // find what day of the week the 1st lands on        
             daysHTML = '',
             i;
         let packingMaterialsDate = $(".packing-material-date").html();
         let collectionMinDate = dateFormat8(dateNow)

         let firstAvailableDate = dateNow.addDays(window.materialDate);
         let foundAvailable = false;
         let availableOffset = window.materialDate;

         if (checkIsCalculatingForFridayBooking(availableOffset)) {
             availableOffset++;
             firstAvailableDate.setDate(firstAvailableDate.getDate() + getOffsetFridayBooking(availableOffset))
         }

         while (foundAvailable == false) {
             if (checkSaturday(availableOffset) == true) {
                 availableOffset++;
                 firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
             } else if (checkSunday(availableOffset) == true) {
                 availableOffset++;
                 firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
             } else {
                 foundAvailable = true;
             }
         }
         collectionMinDate = dateFormat(firstAvailableDate);

         if (packingMaterialsDate.length > 0) {

             foundAvailable = false;
             availableOffset = availableOffset + (window.collectionDate - window.materialDate);
             firstAvailableDate = firstAvailableDate.addDays(window.collectionDate - window.materialDate);

             while (foundAvailable == false) {
                 if (checkSaturday(availableOffset) == true) {
                     availableOffset++;
                     firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
                 } else if (checkSunday(availableOffset) == true) {
                     availableOffset++;
                     firstAvailableDate.setDate(firstAvailableDate.getDate() + 1);
                 } else {
                     foundAvailable = true;
                 }
             }

             collectionMinDate = dateFormat(firstAvailableDate);
         }

         this.selectedDate = [firstAvailableDate.getFullYear(), firstAvailableDate.getMonth(), firstAvailableDate.getDate()];

         let packingMaterialsDateSplit = collectionMinDate.split('/');
         $('.calendar p.monthname').text(this.months[this.themonth] + '  ' + this.theyear); // add month name and year to calendar
         for (i = 0; i < fDay; i++) { // place the first day of the month in the correct position
             daysHTML += '<li class="noclick">&nbsp;</li>';
         }
         // write out the days
         for (i = 1; i <= days; i++) {
             let formatDay = i
             let formatMonth = (this.themonth + 1)
             if (formatDay < 10) {
                 formatDay = '0' + i;
             }
             if (formatMonth < 10) {
                 formatMonth = '0' + (this.themonth + 1)
             }
             var date4 = formatDay + '/' + formatMonth + '/' + this.theyear;
             if (i == 21 && this.themonth == 11) {

             }

             if (dateElement1.includes(date4))
                 daysHTML += '<li class="disable-day manual">' + i + '</li>';
             //  else if (checkweekend(date4))
             // daysHTML += '<li class="weekend disable-day">' + i + '</li>';
             else if (this.today[0] == this.theyear &&
                 this.today[1] == this.themonth &&
                 this.today[2] == i)
                 daysHTML += '<li class="today disable-day">' + i + '</li>';

             else if (this.today[0] == this.theyear &&
                 this.today[1] == this.themonth &&
                 this.today[2] >= i)
                 daysHTML += '<li class="disable-day">' + i + '</li>';
             else if (false && this.today[0] == this.theyear &&
                 this.today[1] == this.themonth &&
                 this.selectedDate[2] >= i)
                 daysHTML += '<li class="disable-day">' + i + '</li>';
             else if (this.today[0] > this.theyear)
                 daysHTML += '<li class="disable-day">' + i + '</li>';
             else if ((i < packingMaterialsDateSplit[0] && this.themonth + 1 == packingMaterialsDateSplit[1]) || this.themonth + 1 < packingMaterialsDateSplit[1] || this.theyear < packingMaterialsDateSplit[2])
                 daysHTML += '<li class="disable-day">' + i + '</li>';
             else if (this.selectedDate[0] == this.theyear &&
                 this.selectedDate[1] == this.themonth + 1 &&
                 this.selectedDate[2] == i)
                 daysHTML += '<li class="active">' + i + '</li>';
             else
                 daysHTML += '<li>' + i + '</li>';

             $('.calendar-body').html(daysHTML); // Only one append call
         }

         // Adds active class to date when clicked
         $('.calendar-body li').click(function() {
             if (!$(this).hasClass('noclick') && !$(this).hasClass('disable-day')) {
                 $('.calendar-body li').removeClass('active');
                 $(this).addClass('active');
                 Calendar.selectedDate = [Calendar.theyear, Calendar.themonth + 1, parseInt($(this).text())]; // save date for reselecting
                 $('.link-checkout .btn.next').removeAttr('disabled');
                 cartNote2 = parseInt($(this).text()) + '/' + (Calendar.themonth + 1) + '/' + Calendar.theyear;
                 cartNote3 = ' (' + $(".time-range-item.active").attr("data-time") + ')'
                 // $.post('/cart.js', {
                 //     attributes: {
                 //         'Collection_date': cartNote2
                 //     }
                 // }).done(function () {
                 //     getCart();
                 // });
                 $.post('/cart.js', {
                     attributes: {
                         'PackingmaterialsDelivery': cartNote,
                         'SubscriptionMonth': months,
                         'CollectionDate': cartNote2,
                         'CollectionTime': cartNote3,
                         'StartDate': startDate
                     }
                 }).done(function() {
                     getCart();
                 });
             }
             if (collectionFeeFlag == false) {
                 setTimeout(function() {
                     addItem(collectionFee);
                 }, 2000);
             }
             checkClick = true;
             var inputFieldCheck = $('#formatted_address_0').val();
             if (inputFieldCheck.length > 0) {
                 setTimeout(function() {
                     $('.step-3 .btn.next').prop('disabled', false);
                     $('[step="3"] .btn.next').prop('disabled', false);
                 }, 3000);
             }
         });
         // Select the first day available

     }
 };
 $(".time-range-item").click(function() {
     $(".time-range-item").removeClass("active");
     $(this).addClass("active");
     cartNote2 = Calendar.selectedDate[2] + '/' + (Calendar.selectedDate[1]) + '/' + Calendar.selectedDate[0];
     cartNote3 = ' (' + $(this).attr("data-time") + ' )';
     $.post('/cart.js', {
         attributes: {
             'PackingmaterialsDelivery': cartNote,
             'SubscriptionMonth': months,
             'CollectionDate': cartNote2,
             'CollectionTime': cartNote3,
             'StartDate': startDate
         }
     }).done(function() {
         getCart();
     });

 });

 $('.total-bar__toggle').click(function() {
     $('.total-bar__toggle').toggleClass('active');
     $('.total-section').toggleClass('active');

     $('.total-bar__toggle-icon').toggleClass('total-bar__toggle-icon__active');

     if ($('.total-section').hasClass('active')) {
         $('html').addClass('total-section-active');
         $('body').addClass('total-section-active');
         $('.total-section').css('max-height', $(window).height() + 'px');
     } else {
         $('html').removeClass('total-section-active');
         $('body').removeClass('total-section-active');
         $('.total-section').css('max-height', 0);
     }
 });

 $('.total-bar__continue').click(function() {
     if ($(this).children('input').prop('disabled')) {
         return;
     }
     let currentStep = $('.container-custom').attr('step');
     let continueButton = $(`.form-container.step-${currentStep} .btn.next`);
     continueButton.click();

     if ($('.total-section').hasClass('active')) {
         $('.total-bar__toggle').click();
     }
 });

 const setRangeArrows = (range) => {
     let months = range.value;
     const min = range.min ? range.min : 0;
     const max = range.max ? range.max : 100;
     const newVal = Number(((months - min) * 100) / (max - min));

     $('.range .range-arrows').css('left', `calc(${newVal}% + (${12.6 - newVal * 0.27}px))`);
 }

 $('.range .range-arrows').hide();
 setTimeout(() => {
     let range = $('.range #months')[0];
     setRangeArrows(range);
     $('.range .range-arrows').show();
 }, 1000);

 $('.range #months').on('input', (e) => {
     let range = e.target;
     setRangeArrows(range);
 })

 $('.popup-des').click(function() {
     if (!$(this).hasClass('show')) {
         return;
     }
     $('.popup-des').removeClass('show');
 });